import {
  CREATE_CUSTOMER_ADDRESS_SUCCEEDED,
  FETCH_CUSTOMER_DETAIL_SUCCEEDED,
  FETCH_CUSTOMER_ADDRESSES_SUCCEEDED,
  FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED,
  DELETE_CUSTOMER_ADDRESS_SUCCEEDED,
  UPDATE_CUSTOMER_ADDRESS_SUCCEEDED,
  UPDATE_CUSTOMER_SUCCEEDED,
  SET_DEFAULT_ADDRESS_SUCCEEDED,
  FETCH_ALL_CUSTOMER_ORDER_SUCCEEDED,
  FETCH_SELLER_PRODUCTS_SUCCESSED,
  FETCH_USER_WISHLIST_SUCCESSED,
  FETCH_WISHLIST_DETAIL_SUCCESSED,
  FETCH_ALL_PRODUCTS_SUCCESSED,
  UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED,
  UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED,
  FETCH_USER_CHECKOUT_SUCCEEDED,
  FETCH_USER_WALLET_REQUESTED,
  FETCH_USER_WALLET_SUCCEEDED,
  DEBIT_WALLET_REQUESTED,
  DEBIT_WALLET_SUCCEEDED,
  CREDIT_WALLET_REQUESTED,
  CREDIT_WALLET_SUCCEEDED,
  GENERATE_COUPON_REQUESTED,
  GENERATE_COUPON_SUCCEEDED
} from './edit.actions';
import * as _ from 'lodash';
import { FETCH_ALL_OFFERS_SUCCESSED, FETCH_OFFER_DETAIL_SUCCESSED, GET_ALL_PRODUCTS_SUCCESSED } from './offers-made/offers-made.actions';

export const edit = (
  state = {
    updated: false,
    fetched: false,
    deleted: false,
    addressUpdated: false,
    paymentUpdated: false,
    item: {},
    address: {},
    addresses: [],
    bankDetail: {
      list: [],
      fetched: false
    },
    orders: {
      fetched: false,
      items: [],
      pagination: null
    },
    seller_products: {
      list: [],
      fetched: false
    },
    wishlist: {
      fetched: false,
      list: [],
      item: {},
      products: []
    },
    offer: {
      list: [],
      fetched: false,
      item: {},
      products: []
    },
    checkout: {
      fetched: false,
      item: {}
    },
    wallet: {
      fetched: false,
      loading: false,
      item: {}
    }
  },
  action
) => {
  switch (action.type) {
    case CREATE_CUSTOMER_ADDRESS_SUCCEEDED:
      return _.assign({}, state, {
        address: action.data,
        fetched: false,
        addresses: [...state.addresses, action.data]
      });
    case FETCH_CUSTOMER_DETAIL_SUCCEEDED:
      return _.assign({}, state, { fetched: true, item: action.data });
    case FETCH_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED:
        return _.assign({}, state, {
          bankDetail: {
            list: action.data,
            fetched: true
          }
      });
    case FETCH_CUSTOMER_ADDRESSES_SUCCEEDED:
      return _.assign({}, state, {
        fetched: true,
        addresses: action.data
      });

    case FETCH_USER_WALLET_REQUESTED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            fetched: false,
            loading: true,
            item: {}
          }
        )
      });
    case FETCH_USER_WALLET_SUCCEEDED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            fetched: true,
            loading: false,
            item: action.data
          }
        )
      });
    case DEBIT_WALLET_REQUESTED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: true,
          }
        )
      });
    case DEBIT_WALLET_SUCCEEDED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: false
          }
        )
      });
    case GENERATE_COUPON_REQUESTED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: true,
          }
        )
      });
    case GENERATE_COUPON_SUCCEEDED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: false
          }
        )
      });
    case CREDIT_WALLET_REQUESTED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: false
          }
        )
      });
    case CREDIT_WALLET_SUCCEEDED:
      return _.assign({}, state, {
        wallet: _.assign(
          {},
          {
            loading: false
          }
        )
      });

    case UPDATE_CUSTOMER_ADDRESS_SUCCEEDED:
      return _.assign({}, state, { addressUpdated: true });

    case UPDATE_CUSTOMER_PAYMENT_DETAIL_SUCCEEDED:
      return _.assign({}, state, { paymentUpdated: true, item: {customer: action.data} });

    case UPDATE_CUSTOMER_PAYMENT_DETAIL_REQUESTED:
      return _.assign({}, state, { paymentUpdated: false });

    case UPDATE_CUSTOMER_SUCCEEDED:
      return _.assign({}, state, { customerUpdated: true, data: action.data });

    case SET_DEFAULT_ADDRESS_SUCCEEDED:
      return _.assign({}, state, {
        addresses: state.addresses.map(item => (item.id === action.data.id ? _.assign({}, item, { is_default: 1 }) : _.assign({}, item, { is_default: 0 })))
      });

    case DELETE_CUSTOMER_ADDRESS_SUCCEEDED:
      return _.assign({}, state, {
        addresses: _.pull([...state.addresses], action.data)
      });

    case FETCH_ALL_CUSTOMER_ORDER_SUCCEEDED:
      return _.assign({}, state, {
        orders: _.assign(
          {},
          {
            fetched: true,
            items: action.data,
            pagination: action.pagination
          }
        )
      });

    case FETCH_SELLER_PRODUCTS_SUCCESSED:
      return _.assign({}, state, {
        seller_products: {
          list: action.data,
          fetched: true
        }
      });

    case FETCH_USER_WISHLIST_SUCCESSED:
      return _.assign({}, state, {
        wishlist: {
          fetched: true,
          list: action.data
        }
      });

    case FETCH_WISHLIST_DETAIL_SUCCESSED:
      return _.assign({}, state, {
        wishlist: {
          fetched: true,
          item: action.data,
          list: []
        }
      });

    case FETCH_USER_CHECKOUT_SUCCEEDED:
      return _.assign({}, state, {
        checkout: {
          fetched: true,
          item: action.data
        }
      });

    case FETCH_ALL_PRODUCTS_SUCCESSED:
      return _.assign({}, state, {
        products: action.data,
        wishlist: _.assign(state.wishlist, {
          products: action.data,
          item: _.assign(_.clone(state.wishlist.item), {
            product: _.find(action.data, item => item.id === (state as any).wishlist.item.product.id)
          })
        })
      });

    case FETCH_ALL_OFFERS_SUCCESSED:
      return _.assign({}, state, {
        offer: _.assign(_.clone(state.offer), {
          list: {
            items: action.data,
            fetched: true
          }
        })
      });

    case FETCH_OFFER_DETAIL_SUCCESSED:
      return _.assign({}, state, {
        offer: _.assign(_.clone(state.offer), {
          item: action.data,
          fetched: true
        })
      });

    case GET_ALL_PRODUCTS_SUCCESSED:
      return _.assign({}, state, {
        offer: _.assign(_.clone(state.offer), {
          products: action.data,
          item: _.assign(_.clone((state as any).offer.item), {
            product: _.find(action.data, item => item.id === (state as any).offer.item.product.id)
          })
        })
      });

    default:
      return state;
  }
};
